import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import NotifsIcon from "../../../../../media/images/icons/notification-bing";
import NavBackButton from "../../../../components/NavBackButton";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "../../../../../media/images/icons/settings-icon";

interface Props {
  hasScroll: boolean;
  title: ReactElement;
}

export default function MobileHeader() {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        zIndex: 10,
        transition: "box-shadow 500ms",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px",
        paddingX: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        <Typography
          sx={{
            fontWeight: "600",
            color: "secondary.main",
          }}
        >
          اعلان‌ها
        </Typography>
      </Box>

      <Button
        onClick={() => navigate("/settings")}
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          gap: "4px",
          borderColor: `${theme.palette.secondary.main} !important`,
          backgroundColor: `${theme.palette.secondary.light} !important`,
          "& .MuiTouchRipple-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
          "& .MuiButtonBase-root": {
            color: `${theme.palette.secondary.main} !important`,
            borderWidth: "0px !important",
          },
        }}
      >
        <SettingsIcon color={theme.palette.secondary.dark} />
        <Typography
          sx={{
            color: "secondary.main",
          }}
        >
          تنظیمات اطلاع‌رسانی
        </Typography>
      </Button>
    </Box>
  );
}
